import { render, staticRenderFns } from "./FormQuebrarAratBdgdConfig.vue?vue&type=template&id=1fd59342&"
import script from "./FormQuebrarAratBdgdConfig.vue?vue&type=script&lang=js&"
export * from "./FormQuebrarAratBdgdConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
